import React from 'react'
import NavigationItem from './NavigationItem'

const DesktopNavigation = (settings) => {
    return(
        <div className="hidden ml-auto space-x-8 lg:flex flex-row">
            {settings.content.header_navigation.map((item, index) => (
                <NavigationItem {...item} key={index} handleDropdownToggled={settings.handleDropdownToggled}/>
            ))}
        </div>
    )    
}

export default DesktopNavigation